import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import { Select, FormControl, InputLabel } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { BASE_URL } from "../../urlConfig/Url";

const EmployeeMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [id, setId] = useState("");
  const [plantCode, setPlantCode] = useState("");
  const [plantCodeError, setPlantCodeError] = useState(false);
  const [department, setDepartment] = useState("");
  const [departmentError, setDepartmentError] = useState(false);
  const [employeeID, setEmployeeID] = useState("");
  const [employeeIDError, setEmployeeIDError] = useState(false);
  const [fName, setFName] = useState("");
  const [fNameError, setFNameError] = useState(false);
  const [lName, setLName] = useState("");
  const [lNameError, setLNameError] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState(false);

  const [status, setStatus] = useState("");
  const [statusError, setStatusError] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [cName, setCName] = useState([]);
  const [cNameTwo, setCNameTwo] = useState([]);
  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchCompanies();
    fetchCompaniesName();
    fetchCompaniesNameTwo();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/SelectAllEmployeeDepartmentMaster"
      );
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesName = async () => {
    try {
      const response = await axios.post(BASE_URL + "/api/master/getPlantCode");
      if (response.data.success) {
        setCName(response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesNameTwo = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/SelectAllDepartmentMaster"
      );
      if (response.data.success) {
        setCNameTwo(response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  const formvalidation = () => {
    let isValid = true;
    if(plantCode === ""){
      setPlantCodeError(true);
      isValid = false;
    }else{
      setPlantCodeError(false);
    }
    if (department === "") {
      setDepartmentError(true);
      isValid = false;
    }else{
      setDepartmentError(false);
    }
    if (employeeID === "") {
      setEmployeeIDError(true);
      isValid = false;
    }else{
      setEmployeeIDError(false);
    }
    if (fName === "") {
      setFNameError(true);
      isValid = false;
    }else{       
      setFNameError(false);
    }
    if (lName === "") {
      setLNameError(true);
      isValid = false;
    }else{
      setLNameError(false);
    }
    if (email === "") {
      setEmailError(true);
      isValid = false;
    }else{
      setEmailError(false);
    } 

    if (mobile === "") {
      setMobileError(true);
      isValid = false;
    } else{
      setMobileError(false);
    }
    if (status === "") {
      setStatusError(true);
      isValid = false;
    }else{
      setStatusError(false);
    }
    return isValid;

   
  }

  const onSubmit = async () => {
   if (formvalidation()){
     
   
    const data = {
      Plant: plantCode,
      Department: department,
      Employee_ID: employeeID,
      FirstName: fName,
      LastName: lName,
      EmailID: email,
      MobileNo: mobile,
      EmpStatus: status,
      CreatedBY: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/insertEmployeeDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  }else{
    toast.error("Please fill all the fields");
  }
  };

  const onUpdate = async () => {
    const data = {
      Plant: plantCode,
      Department: department,
      Employee_ID: employeeID,
      FirstName: fName,
      LastName: lName,
      EmailID: email,
      MobileNo: mobile,
      EmpStatus: status,
      ModifiedBy: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/updateEmployeeDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setId("");
    setPlantCode("");
    setDepartment("");
    setEmployeeID("");
    setFName("");
    setLName("");
    setEmail("");
    setMobile("");
    setStatus("");
  };

  const handleAddNew = () => {
    setFormMode("add");
    resetForm();
    stopErrorHelper();
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
    stopErrorHelper();
  };

  useEffect(() => {
    const result = companies.filter((company) =>
      Object.entries(company).some(([key, value]) => {
        // Skip null or undefined values
        if (value == null) return false;

        // Convert to string and compare
        return value
          .toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      })
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.trim());
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const stopErrorHelper = ()=>{
    setPlantCodeError(false);
    setDepartmentError(false);
    setEmployeeIDError(false);
    setFNameError(false);
    setLNameError(false);
    setEmailError(false);
    setMobileError(false);
    setStatusError(false);


  }

  const handleRowSelect = (company) => {
    setId(company.Seqid);
    setPlantCode(company.Plant);
    setDepartment(company.Department);
    setEmployeeID(company.Employee_ID);
    setFName(company.First_Name);
    setLName(company.Last_Name);
    setEmail(company.Email_ID);
    setMobile(company.Mobile_No);
    setStatus(company.EmpStatus);

    setFormMode("edit");
    stopErrorHelper();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{ mt: 1, mb: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              to="/dashboard/dashbordhome"
              style={{
                textDecoration: "none",
                color: theme.palette.primary.main,
              }}
            >
              Home
            </Link>
            <Typography color="textPrimary">Employee Master</Typography>
          </Breadcrumbs>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Employee Master (* Fields Are Mandatory)
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Plant Code (*)"
                  name="Plant Code"
                  fullWidth
                  size="small"
                  value={plantCode}
                  error={plantCodeError}
                  helperText={plantCodeError ? "Plant Code is required" : ""}
                  onChange={(e) => setPlantCode(e.target.value)}
                  disabled={formMode === "initial" }
                >
                  {cName.map((company) => (
                    <MenuItem key={company.PlantCode} value={company.PlantCode}>
                      {company.PlantCode}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Department (*)"
                  name="Department"
                  fullWidth
                  size="small"
                  value={department}
                  error={departmentError}
                  helperText={
                    departmentError ? "Department is required" : ""
                  }
                  onChange={(e) => setDepartment(e.target.value)}
                  disabled={formMode === "initial"}
                >
                  {cNameTwo.map((company) => (
                    <MenuItem
                      key={company.Department}
                      value={company.Department}
                    >
                      {company.Department}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Employee ID (*)"
                  name="EmployeeID"
                  fullWidth
                  size="small"
                  value={employeeID}
                  error={employeeIDError}
                  helperText={
                    employeeIDError ? "Employee ID is required" : ""
                  }
                  
                  onChange={(e) => setEmployeeID(e.target.value)}
                  disabled={formMode === "initial" || formMode === "edit"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="First Name (*) "
                  name="First Name"
                  fullWidth
                  size="small"
                  value={fName}
                  error={fNameError}
                  helperText={
                    fNameError ? "First Name is required" : ""
                  }
                  
                  onChange={(e) => setFName(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Last Name (*) "
                  name="Last Name"
                  fullWidth
                  size="small"
                  value={lName}
                  error={lNameError}
                  helperText={
                    lNameError ? "Last Name is required" : ""
                  }
                  onChange={(e) => setLName(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Email Id "
                  name="Email Id"
                  fullWidth
                  size="small"
                  value={email}
                  error={emailError}
                  helperText={
                    emailError ? "Email Id is required" : ""
                  }
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Mobile Number "
                  name="Mobile Number"
                  fullWidth
                  size="small"
                  value={mobile}
                  error={mobileError}
                  helperText={
                    mobileError ? "Mobile Number is required" : ""
                  
                  }
                  onChange={(e) => setMobile(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Status(*)"
                  name="Status"
                  fullWidth
                  size="small"
                  value={status}
                  error={statusError}
                  helperText={
                    statusError ? "Status is required" : ""
                  }
                  onChange={(e) => setStatus(e.target.value)}
                  disabled={formMode === "initial"}
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Deactive">Deactive</MenuItem>
                </TextField>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" mt={5} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    <AddIcon />
                    Add New
                  </Button>
                </Grid>
              )}

              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      <AddIcon />
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}

              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      <ChangeCircleIcon />
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 100 }}
              >
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                  labelId="rows-per-page-label"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 250 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <div class="table-container">
              <table class="responsive-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Plant</th>
                    <th>Email ID</th>
                    <th>Employee ID</th>
                    <th>Employee Name</th>
                    <th>Email Id</th>
                    <th>Mobile No</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Modified By</th>
                    <th>Modified Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRows.map((company) => (
                    <tr key={company.Seqid}>
                      <td data-label="Select">
                        <button onClick={() => handleRowSelect(company)}>
                          Select
                        </button>
                      </td>
                      <td data-label="Plant">{company.Plant}</td>
                      <td data-label="Department">{company.Department}</td>
                      <td data-label="Employee ID">{company.Employee_ID}</td>
                      <td data-label="Employee Name">{company.EmployeeName}</td>
                      <td data-label="Email Id" style={{ textAlign: "center" }}>
                        {company.Email_ID}
                      </td>
                      <td data-label="Mobile No">{company.Mobile_No}</td>
                      <td data-label="Status">{company.EmpStatus}</td>
                      <td data-label="Created By">{company.Created_By}</td>
                      <td data-label="Created Date">
                        {new Date(company.Created_Date).toLocaleString()}
                      </td>
                      <td data-label="Modified By">{company.Modified_By}</td>
                      <td data-label="Modified Date">
                        {company.Modified_Date
                          ? new Date(company.Modified_Date).toLocaleString()
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ marginRight: 2 }}>
                Showing {(page - 1) * rowsPerPage + 1} to{" "}
                {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                {filteredRows.length} entries
              </Typography>
              <Pagination
                count={Math.ceil(filteredRows.length / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                size="small"
              />
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default EmployeeMaster;
